module.exports = __webpack_public_path__ + "img/game2.1.18dc0f25.png";